export enum XpressDisciplinaryType {
    None = 0,
    Manually = 1,
    Automated = 2
}
